<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="create" icon="el-icon-plus"
          >添加采购需求单</el-button
        >
      </template>
      <template slot="column">
        <!-- <el-table-column label="操作" fixed="right" align="center" width="60"> -->
        <el-table-column label="操作" fixed="right" align="center" width="240">
          <template slot-scope="{ row }">
            <el-button
              v-if="$permission.canRead()"
              type="text"
              @click="details(row)"
              >查看</el-button
            >
            <el-button
              v-if="$permission.canWrite()"
              type="text"
              :disabled="row.Status === 1"
              @click="edit(row)"
              >编辑</el-button
            >
            <el-button
              v-if="$permission.canWrite()"
              type="text"
              @click="delRows(row)"
               :disabled="row.Status === 1"
              >删除</el-button
            >
            <el-button v-if="$permission.canWrite()" @click="createOrder(row)" type="text"
             :disabled="row.Status === 1||isSave"
              >{{ PurchaseCreateSeletText }}</el-button
            >
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @saved="saved"></edit-dialog>
    <demand-order ref="demandOrder" :isCreate="isCreate" @close-saved="reload"></demand-order>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/production/clothmanagement/demand/list";
import editDialog from "@/components/production/clothmanagement/demand/editDialog";
import demandOrder from "@/components/production/clothmanagement/demand/demandOrder";

export default {
  name: "demand",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    demandOrder,
  },
  data(){
    return {
      api: require('@/api/pu/puPurchaseDemand').default,
      isCreate: true,
      isSave:false,
      PurchaseCreateSeleted: null,
    }
  },
  created() { 
    this.$store.dispatch("getPurchaseSetting").then(res => {
      console.log('res', res)
      this.PurchaseCreateSeleted = res.PurchaseCreateSeleted;
    })
  },
  activated() { 
    this.$store.dispatch("getPurchaseSetting").then(res => {
      console.log('res', res)
      this.PurchaseCreateSeleted = res.PurchaseCreateSeleted;
    })
  },
  computed: {
    PurchaseCreateSeletText(){
      return this.PurchaseCreateSeleted === 0  ? '生成采购订单' : '生成请购单'
    }
  },
  methods: {
    createOrder({PurchaseDemandId}){
      this.isSave=true; 
      if(this.PurchaseCreateSeleted === 0){
        this.api.createOrder({Id: PurchaseDemandId}).then(res => {
          if(res.Code === 0){          
            this.$message({'type': 'success', message: res.Msg})
            this.reload();
          }else{
            this.$message({'type': 'warning', message: res.Msg})
          }
          this.isSave=false;
        }).catch(err => {
          this.$message({'type': 'warning', message: res.Msg})
        })
      }else{
        this.api.create({Id: PurchaseDemandId}).then(res => {
          if(res.Code === 0){          
            this.$message({'type': 'success', message: res.Msg})
            this.reload();
          }else{
            this.$message({'type': 'warning', message: res.Msg})
          }
          this.isSave=false;
        }).catch(err => {
          this.$message({'type': 'warning', message: res.Msg})
        })
      }
      
    },
    saved({list, type}) {
      // let that = this;
      let data = [];
      if(type === 'tab1'){
        data = list
      }else{
        list.forEach(item => {
          data.push(...item.VPrWorkDocMaterialList)
        })
      }
      this.isCreate = true;
      
      this.$refs.demandOrder.openCreate(data)
      // this.$refs.demandOrder.open().then(() => {
        
      // });
    },
    details(row) {
       this.isCreate = false;
      this.$refs.demandOrder.openDetails(row);
    },
    edit(row) {
      this.isCreate = false;
      this.$refs.demandOrder.openEdit(row);
    },
    // create() {
    //   this.$refs.demandOrder.openCreate();
    // },
    delRows(row) {
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = [row.PurchaseDemandId];
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    // _create(){
    //   this.$refs.editDialog.open().then(res => {
    //     this.$refs.editDialog._getData();
    //   })
    // },
    // _detailsById(id){
    //     let that = this;
    //   this.$refs.demandOrder.open().then(res => {
    //       that.$refs.demandOrder._getDataInfo(id);
    //     })
    // }
  },
};
</script>
